import { ButtonApiErrorWrapper } from 'app/components/shared/ButtonApiErrorWrapper'
import { BgShapes } from 'app/components/ui/BgShapes'
import { Button } from 'app/components/ui/Button'
import { Container } from 'app/components/ui/Container'
import { Form } from 'app/components/ui/Form'
import { useUploadSponsorRequestFiles } from 'app/queries/sponsorRequests'
import { ScrollToTop } from 'app/routing/ScrollToTop'
import { SponsorRequest } from 'EstraSponsor'
import React from 'react'
import styled, { useTheme } from 'styled-components'

import {
  adaptFormDataToApi,
  adaptApiToFormData,
  SponsorRequestFilesFormData,
  sponsorRequestFilesValidationSchema,
} from './form'
import { SponsorRequestFilesInnerForm } from './SponsorRequestFilesInnerForm'

type Props = {
  sponsorRequest: SponsorRequest
  onPreviousStep: (currentSponsorRequest: SponsorRequest) => void
  onNextStep: () => void
}
export const SponsorRequestFilesForm = ({
  sponsorRequest,
  onPreviousStep,
  onNextStep,
}: Props): JSX.Element => {
  const theme = useTheme()

  const {
    mutate: uploadSponsorRequest,
    isLoading,
    error,
  } = useUploadSponsorRequestFiles()

  return (
    <>
      <ScrollToTop />

      <Form<SponsorRequestFilesFormData>
        defaultValues={adaptApiToFormData(sponsorRequest)}
        validationSchema={sponsorRequestFilesValidationSchema}
        onSubmit={(data: SponsorRequestFilesFormData) => {
          uploadSponsorRequest(
            {
              sponsor_request_id: sponsorRequest.id.toString(),
              formData: adaptFormDataToApi(data),
            },
            {
              onSuccess: onNextStep,
            }
          )
        }}
      >
        <BgShapes
          bgColor={theme.color.neutri.grigioBg}
          variant='form-section-short'
        >
          <FormWrapper>
            <SponsorRequestFilesInnerForm sponsorRequest={sponsorRequest} />{' '}
          </FormWrapper>
        </BgShapes>
        <ActionContainer>
          <ButtonApiErrorWrapper isError={!!error} error={error} alignCenter>
            <ButtonsWrapper>
              <Button
                size='lg'
                onClick={() => onPreviousStep(sponsorRequest)}
                variant='grey'
              >
                Indietro
              </Button>
              <Button size='lg' type='submit' disabled={isLoading}>
                {isLoading ? 'Caricamento...' : 'Conferma'}
              </Button>
            </ButtonsWrapper>
          </ButtonApiErrorWrapper>
        </ActionContainer>
      </Form>
    </>
  )
}

const FormWrapper = styled.div`
  padding: 2rem 0 1rem 0;
`

const ActionContainer = styled(Container)`
  margin-top: 3rem;
`

const ButtonsWrapper = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
`
